import {
    DropdownV2,
    Icon,
    ListItem,
    PriorityIcon,
    TriggerWrapperV2,
    Text
} from '@priority-software/priority-style-react';
import React, {useState} from 'react';
import texts from '../../texts';
import styles from './styles.module.scss';

interface Props {
    onDuplicate: () => void;
    onDelete: () => void;
    isSameUser: boolean;
    isOldReport: boolean;
}

const MenuActions = ({onDelete, onDuplicate, isSameUser, isOldReport}: Props) => {
    const [isOpen, setIsOpen] = useState(false);

    const handleDelete = () => {
        onDelete();
        setIsOpen(false);
    };

    const handleDuplicate = () => {
        onDuplicate();
        setIsOpen(false);
    };
    return (
        <DropdownV2
            openingSide="leftSide"
            contentComponentClasses={styles.dropdownSection}
            isOpen={isOpen}
            onClose={() => setIsOpen(false)}
            trigger={
                <TriggerWrapperV2 isOpen={isOpen}>
                    <Icon
                        iconColor="secondary-400"
                        onClick={() => setIsOpen(prev => !prev)}
                        icon={PriorityIcon.threeDots}
                    />
                </TriggerWrapperV2>
            }
        >
            <ListItem
                isActive={false}
                disabled={isOldReport}
                isFocused={false}
                onClick={!isOldReport ? handleDuplicate : undefined}
            >
                <Text>{texts.duplicate}</Text>
            </ListItem>
            <ListItem
                disabled={isOldReport || !isSameUser}
                isActive={false}
                isFocused={false}
                onClick={isSameUser ? handleDelete : undefined}
            >
                <Text textColor={isSameUser ? 'validation-red' : 'grey-light'}>{texts.delete}</Text>
            </ListItem>
        </DropdownV2>
    );
};

export default MenuActions;
